<template>
  <div class="container">
    <div class="bgoverlay">
      <div class="bg" :style="{'background-image': `url(${require('@/assets/images/servicesbg4.jpg')})`}"></div>
    </div>
    <div class="inner-pannel">
      <div class="pannel-content">
        <div class="pannel-content-box maxwidth-lg topPoint">
          <!-- <h2></h2> -->
          <div style="height:55px;"></div>
          <div class="content-page">
            <div class="ani animate__animated animate__fadeInUp">
              <div :class="$i18n.locale=='zh'?'text zh-font':'text en-font'">{{$t('internationalFreight[0].content1')}}</div>
              <div style="height:20px;"></div>
              <el-collapse
              style="width:79%"
                :accordion="true"
                v-model="activeName"
              >
                <el-collapse-item :title="$t('internationalFreight[0].title1')" name="0">
                  <div style="height:20px;"></div>
                  <div class="item-box">
                    <div class="item-box-item">
                      <img src="../../assets/images/konghaiyun.svg">
                      <div style="color:#ffffff">{{$t('internationalFreight[0].list1[0].text1')}}</div>
                    </div>
                    <div class="item-box-item">
                      <img src="../../assets/images/luyun.svg">
                      <div style="color:#ffffff">{{$t('internationalFreight[0].list1[3].text1')}}</div>
                    </div>
                    <div class="item-box-item">
                      <img src="../../assets/images/tieyun.svg">
                      <div style="color:#ffffff">{{$t('internationalFreight[0].list1[6].text1')}}</div>
                    </div>
                    <div class="item-box-item">
                      <img src="../../assets/images/kongyunliang.svg">
                      <div class="font24">{{$t('internationalFreight[0].list1[1].text1')}}</div>
                      <div style="height:10px;"></div>
                      <div class="font-color">{{$t('internationalFreight[0].list1[1].text2')}}</div>
                    </div>
                    <div class="item-box-item">
                      <img src="../../assets/images/huocheliang.svg">
                      <div class="font24">{{$t('internationalFreight[0].list1[4].text1')}}</div>
                      <div style="height:10px;"></div>
                      <div class="font-color">{{$t('internationalFreight[0].list1[4].text2')}}</div>
                    </div>
                    <div class="item-box-item">
                      <img src="../../assets/images/huoguiliang.svg">
                      <div class="font24">{{$t('internationalFreight[0].list1[7].text1')}}</div>
                      <div style="height:10px;"></div>
                      <div class="font-color">{{$t('internationalFreight[0].list1[7].text2')}}</div>
                    </div>
                    <div class="item-box-item">
                      <img src="../../assets/images/haiyunliang.svg">
                      <div class="font24">{{$t('internationalFreight[0].list1[2].text1')}}</div>
                      <div style="height:10px;"></div>
                      <div class="font-color">{{$t('internationalFreight[0].list1[2].text2')}}</div>
                      <!-- <div class="font-color"></div> -->
                    </div>
                    <div class="item-box-item">
                      <img src="../../assets/images/huoyunzhan.svg">
                      <div class="font24">{{$t('internationalFreight[0].list1[5].text1')}}</div>
                      <div style="height:10px;"></div>
                      <div class="font-color">{{$t('internationalFreight[0].list1[5].text2')}}</div>
                    </div>
                    <div class="item-box-item">
                      <img src="../../assets/images/matouzhan.svg">
                      <div class="font24">{{$t('internationalFreight[0].list1[8].text1')}}</div>
                      <div style="height:10px;"></div>
                      <div class="font-color">{{$t('internationalFreight[0].list1[8].text2')}}</div>
                    </div>
                  </div>
                </el-collapse-item>
                <el-collapse-item :title="$t('internationalFreight[0].title2')" name="1">
                  <div style="height:20px;"></div>
                  <div class="item-box">
                    <div class="item-box-item">
                      <img src="../../assets/images/konghaiyun.svg">
                      <div style="color:#ffffff;">{{$t('diversifiedtransport[1].list1[0].text1')}}</div>
                    </div>
                    <div class="item-box-item">
                      <img src="../../assets/images/luyun.svg">
                      <div style="color:#ffffff;">{{$t('diversifiedtransport[1].list1[3].text1')}}</div>
                    </div>
                    <div class="item-box-item">
                      <img src="../../assets/images/tieyun.svg">
                      <div style="color:#ffffff;">{{$t('diversifiedtransport[1].list1[6].text1')}}</div>
                    </div>
                  </div>  
                <!-- <img style="width:100%" src="../../assets/images/fangan.svg"> -->
                <div class="masonry">
                  <div class="column1">
                      <div class="item">
                          <div class="item__content" v-html="$t('diversifiedtransport[1].list2.item1[0]')"></div>
                      </div>
                      <div class="item">
                          <div class="item__content" v-html="$t('diversifiedtransport[1].list2.item1[2]')"></div>
                      </div>
                      <div class="item">
                          <div class="item__content" v-html="$t('diversifiedtransport[1].list2.item1[4]')"></div>
                      </div>
                      <div class="item">
                          <div class="item__content" v-html="$t('diversifiedtransport[1].list2.item1[6]')"></div>
                      </div>
                  </div>
                  <div class="column">
                      <div class="item">
                          <div class="item__content" v-html="$t('diversifiedtransport[1].list2.item2[0]')"></div>
                      </div>
                      <div class="item">
                          <div class="item__content" v-html="$t('diversifiedtransport[1].list2.item2[2]')"></div>
                      </div>
                      <div class="item">
                          <div class="item__content" v-html="$t('diversifiedtransport[1].list2.item2[4]')"></div>
                      </div>
                      <div class="item">
                          <div class="item__content" v-html="$t('diversifiedtransport[1].list2.item2[6]')"></div>
                      </div>
                  </div>
                  <div class="column2">
                      <div class="item">
                          <div class="item__content" v-html="$t('diversifiedtransport[1].list2.item3[0]')"></div>
                      </div>
                      <div class="item">
                          <div class="item__content" v-html="$t('diversifiedtransport[1].list2.item3[2]')"></div>
                      </div>
                      <div class="item">
                          <div class="item__content" v-html="$t('diversifiedtransport[1].list2.item3[4]')"></div>
                      </div>
                      <div class="item">
                          <div class="item__content" v-html="$t('diversifiedtransport[1].list2.item3[6]')"></div>
                      </div>
                  </div>
              </div>
              <div style="height:20px"></div>
              <div class="masonry">
                  <div class="column1">
                      <div class="item">
                          <div class="item__content" v-html="$t('diversifiedtransport[1].list2.item1[1]')"></div>
                      </div>
                      <div class="item">
                          <div class="item__content" v-html="$t('diversifiedtransport[1].list2.item1[3]')"></div>
                      </div>
                      <div class="item">
                          <div class="item__content" v-html="$t('diversifiedtransport[1].list2.item1[5]')"></div>
                      </div>
                      <div class="item">
                          <div class="item__content" v-html="$t('diversifiedtransport[1].list2.item1[7]')"></div>
                      </div>
                  </div>
                  <div class="column">
                      <div class="item">
                          <div class="item__content" v-html="$t('diversifiedtransport[1].list2.item2[1]')"></div>
                      </div>
                      <div class="item">
                          <div class="item__content" v-html="$t('diversifiedtransport[1].list2.item2[3]')"></div>
                      </div>
                      <div class="item">
                          <div class="item__content" v-html="$t('diversifiedtransport[1].list2.item2[5]')"></div>
                      </div>
                      <div class="item">
                          <div class="item__content" v-html="$t('diversifiedtransport[1].list2.item2[7]')"></div>
                      </div>
                  </div>
                  <div class="column2">
                      <div class="item">
                          <div class="item__content" v-html="$t('diversifiedtransport[1].list2.item3[1]')"></div>
                      </div>
                      <div class="item">
                          <div class="item__content" v-html="$t('diversifiedtransport[1].list2.item3[3]')"></div>
                      </div>
                      <div class="item">
                          <div class="item__content" v-html="$t('diversifiedtransport[1].list2.item3[5]')"></div>
                      </div>
                  </div>
              </div>
                  <!-- <img style="width:100%" src="../../assets/images/fangan.svg"> -->
                  <!-- <div class="flex">
                    <div class="main">
                      <div v-for="(item,index) in $t('internationalFreight[0].list2.item1')" :key="index" style="width:50%" class="flex">
                        <span style="display:inline-block">·</span>
                        <div class="right-item" v-html="item"></div>
                      </div>
                    </div>
                    <div class="main">
                      <div v-for="(item,index) in $t('internationalFreight[0].list2.item2')" :key="index" style="width:50%" class="flex">
                        <span style="display:inline-block">·</span>
                        <div class="right-item" v-html="item"></div>
                      </div>
                    </div>
                    <div class="main">
                      <div v-for="(item,index) in $t('internationalFreight[0].list2.item3')" :key="index" style="width:50%" class="flex">
                        <span style="display:inline-block">·</span>
                        <div class="right-item" v-html="item"></div>
                      </div>
                    </div>
                  </div> -->
                </el-collapse-item>
              </el-collapse>    
              <!-- <div class="main">
                <div class="main-item-left">
                  <div class="item-title">{{$t('internationalFreight[0].title1')}}</div>
                  <div style="height:20px;"></div>
                  <div class="item-box">
                    <div>
                      <img src="../../assets/images/konghaiyun.svg">
                      <div>{{$t('internationalFreight[0].list1[0].text1')}}</div>
                    </div>
                    <div class="item-box-item">
                      <img src="../../assets/images/kongyunliang.svg">
                      <div class="font24">{{$t('internationalFreight[0].list1[1].text1')}}</div>
                      <div style="height:10px;"></div>
                      <div class="font-color">{{$t('internationalFreight[0].list1[1].text2')}}</div>
                    </div>
                    <div class="item-box-item">
                      <img src="../../assets/images/haiyunliang.svg">
                      <div class="font24">{{$t('internationalFreight[0].list1[2].text1')}}</div>
                      <div style="height:10px;"></div>
                      <div class="font-color">{{$t('internationalFreight[0].list1[2].text2')}}</div>
                      <div class="font-color">{{$t('internationalFreight[0].list1[2].text3')}}</div>
                    </div>
                    <div>
                      <img src="../../assets/images/luyun.svg">
                      <div>{{$t('internationalFreight[0].list1[3].text1')}}</div>
                    </div>
                    <div class="item-box-item">
                      <img src="../../assets/images/huocheliang.svg">
                      <div class="font24">{{$t('internationalFreight[0].list1[4].text1')}}</div>
                      <div style="height:10px;"></div>
                      <div class="font-color">{{$t('internationalFreight[0].list1[4].text2')}}</div>
                    </div>
                    <div class="item-box-item">
                      <img src="../../assets/images/huoyunzhan.svg">
                      <div class="font24">{{$t('internationalFreight[0].list1[5].text1')}}</div>
                      <div style="height:10px;"></div>
                      <div class="font-color">{{$t('internationalFreight[0].list1[5].text2')}}</div>
                    </div>
                    <div>
                      <img src="../../assets/images/tieyun.svg">
                      <div>{{$t('internationalFreight[0].list1[6].text1')}}</div>
                    </div>
                    <div class="item-box-item">
                      <img src="../../assets/images/huoguiliang.svg">
                      <div class="font24">{{$t('internationalFreight[0].list1[7].text1')}}</div>
                      <div style="height:10px;"></div>
                      <div class="font-color">{{$t('internationalFreight[0].list1[7].text2')}}</div>
                    </div>
                    <div class="item-box-item">
                      <img src="../../assets/images/matouzhan.svg">
                      <div class="font24">{{$t('internationalFreight[0].list1[8].text1')}}</div>
                      <div style="height:10px;"></div>
                      <div class="font-color">{{$t('internationalFreight[0].list1[8].text2')}}</div>
                    </div>
                  </div>
                </div>
                <div class="main-item-right">
                  <div class="item-title">{{$t('internationalFreight[0].title2')}}</div>
                  <div style="height:20px;"></div>
                  <div class="main">
                    <div class="right-item" v-for="(item,index) in $t('internationalFreight[0].list2.item1')" :key="index">{{ item }}</div>
                  </div>
                  <div style="height:50px;"></div>
                  <div class="main">
                    <div class="right-item" v-for="(item,index) in $t('internationalFreight[0].list2.item2')" :key="index">{{ item }}</div>
                  </div>
                  <div style="height:50px;"></div>
                  <div class="main">
                    <div class="right-item" v-for="(item,index) in $t('internationalFreight[0].list2.item3')" :key="index">{{ item }}</div>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
    data() {
        return{
            activeName: ''
        }
    }
}
</script>

<style scoped>
    .masonry {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
    }
    .column {
      display: flex;
      flex-direction: column;
      /* width: calc(100%/3); */
      width: 25%;
    }
    .column1 {
      display: flex;
      flex-direction: column;
      /* width: calc(100%/3); */
      width: 21%;
    }
    .column2 {
      display: flex;
      flex-direction: column;
      /* width: calc(100%/3); */
      width: 17%;
    }
    .item__content{
      color: #ffffff;
    }
    .topPoint::after {
        width: 25px;
        height: 25px;
        content: "";
        position: absolute;
        background: #ed6d00;
        border-radius: 50%;
        z-index: 1;
        top: -12.5px;
        right: -12.5px;
    }
    /deep/ .el-collapse-item__wrap{
      padding-left: 0;
    }
    /deep/ .el-collapse-item__header{
      color: #ffffff;
    }
    /deep/ .el-collapse {
      border-bottom: 0;
    }
    /deep/ .el-collapse-item__wrap{
      border-bottom: 0;
    }
    .flex{
      display: flex; 
    }
    .inner-pannel{
      min-height: 100%;
      padding-bottom: 54px;
      position: static;
      /* position: relative; */
      /* position: absolute; */
      width: 100%;
      font-family: 'Lato''Microsoft JhengHei';
    }
    .main{
      width: 33.33%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      color: #ffffff;
      align-items:  flex-start;
    }
    .main-item-left{
      width: 50%;
    }
    .main-item-right{
      width: 40%;
    }
    .item-title{
      font-weight: 500;
      color: #ED6D00;
    }
    .item-box{
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
    .item-box-item{
      width: 33.33%;
      /* width: 200px; */
      text-align: center;
      margin-bottom: 40px;
    }
    .item-box-item img{
      height: 60px;
    }
    .font24{
      font-size: 20px;
      color: #ED6D00;
      /* font-weight: 500; */
    }
    .font-color{
      color: #ED6D00;
    }
    .right-item{
      /* width: 50%; */
      /* margin-bottom: 8px; */
    }
    /* >=1300 <=1600*/
    @media only screen and (min-width: 1300px) and (max-width: 1600px){
      .item-box-item{
        /* width: 150px; */
      }
      .font24{
        font-size: 20px;
    }
    }
    @media screen and (max-width:768px) {
      .item-box-item{
        width: 33.33%;
      }
      .flex{
        flex-wrap: wrap;
      }
      .main{
        width: 100%;
      }
      /deep/ .el-collapse {
        width: 100%!important;
      }
    }
</style>


// WEBPACK FOOTER //
// src/components/internationalFreight/internationalFreight.vue